<template>
  <main-layout>
    <back-btn-toolbar class="pl-3 mt-1">
      <b-button :disabled="compare()" variant="primary" @click="save" class="mr-1">Sauver</b-button>
      <b-button variant="primary" @click="logAs">Log As</b-button>
    </back-btn-toolbar>
    <b-col lg="6" class="pt-2 pb-2" v-for="op in shownOptions.filter(o=>(!o.hide && (!o.if || o.if())))"
           :key="op.key">
      <b-input-group :prepend="op.label">
        <b-form-input
            v-if="!op.editable || op.editable.type === 'input' || op.editable.type === 'checkbox'"
            v-model="userParams[op.key]"
            :disabled="!op.editable || op.editable.type === 'checkbox'"/>
        <b-form-select
            v-else-if="op.editable.type === 'select'"
            :options="op.editable.options"
            v-model="userParams[op.key]"
        />
        <v-select v-else-if="op.editable && op.editable.type === 'select2'"
                  v-model="userParams[op.key]"
                  :options="op.editable.options"
                  :reduce="o=>o.value"
                  multiple>
        </v-select>
        <b-input-group-append is-text v-if="op.editable && op.editable.type === 'checkbox'">
          <b-form-checkbox switch class="mr-n2" :checked="!!userParams[op.key]" @input="op.editable.$input"/>
        </b-input-group-append>
        <b-input-group-append is-text v-if="op.editable && op.editable.type === 'radio'">
          <b-radio-group
              :options="op.editable.options"
              v-model="userParams[op.key]"
          />
        </b-input-group-append>

      </b-input-group>
    </b-col>
    <b-card no-body class="ml-3">
      <b-card-header v-b-toggle.collapse class="text-center toggle">Notes</b-card-header>
      <b-collapse id="collapse">
        <b-card-body class="p-0">
          <vue-editor
              id="editor"
              v-model="userParams.notes"
          />
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-paginated-table
        v-if="userParams.role === 2"
        ref="table"
        :items="exercices"
        :fields="fields"
        :current-page="currentPage"
        persistant
        primary-key="key"
    >
      <template #cell(titre)="{item, value}">
        <router-link :to="`/admin/exercices/${item.id}`" target="_blank">{{ value }}</router-link>
      </template>
      <template #cell(status)="{item:{texte_id,fini,corrige}}">
        <texte-status :key="texte_id" :text="texte_id" :fini="fini" :corrige="corrige"/>
      </template>
      <template #cell(Action)="{item}">
        <b-button :variant="getActionsVariant(item)" @click="getAction(item)">{{
            getActionsLabel(item)
          }}
        </b-button>
      </template>
    </b-paginated-table>
  </main-layout>
</template>

<script>
import {VueEditor} from "vue2-editor";
import BackBtnToolbar from "../../components/back-btn-toolbar";
import BPaginatedTable from "../../components/BPaginatedTable";
import {History} from "@/js/history";
import {Auth, Exercice, Textes, User} from "@/js/caller";
import {StatusList} from "@/lib/TextesUtils/utils";
import TexteStatus from "@/components/status/TexteStatus";
import {DataFormat} from "@/js/utils";

const niveaux = DataFormat.Exercices.Niveau;
const types = DataFormat.Exercices.Type;

function getTextType(type) {
  switch (type) {
    case "PO":
      return 2
    default:
      return 1
  }
}


export default {
  name: "EleveView",
  components: {TexteStatus, VueEditor, BPaginatedTable, BackBtnToolbar},
  data() {
    const options = this.getOptions();
    return {
      user: {
        id: this.$route.params.id
      },
      userParams: {},
      exercices: [],
      eleves: [],
      status: StatusList(),
      options,
      currentPage: 1,
    }
  },
  computed: {
    shownOptions() {
      return this.options
          .map(
              ({key, label, ...other}) => {
                return {
                  key,
                  label: label || (key[0].toUpperCase() + key.slice(1)),
                  value: this.user[key],
                  ...other
                }
              }
          )
    },
    fields() {
      return [
        {key: 'type', filterable: types},
        {key: 'niveau', filterable: niveaux},
        {key: 'titre', filterable: true},
        {key: 'status', filterable: this.status},
        'Action'
      ]
    },
  },
  methods: {
    getKey(item) {
      return item.id + item.texte_id ? "-" + item.texte_id : "";
    },
    getStatusLabel(item) {
      const {status} = this;
      return !item.texte_id ? "" : (
          item.corrige ? status[3] : (
              item.fini ?
                  status[2] :
                  status[1]
          )
      );
    },
    getStatusVariant(item) {
      return !item.texte_id ? "" : (
          item.corrige ? "primary" : (
              item.fini ? "success" : "warning"
          )
      );
    },
    getActionsLabel(item) {
      return item.texte_id ? "Voir" : "Envoyer";
    },
    getActionsVariant(item) {
      return item.texte_id ? "primary" : "secondary";
    },
    getAction(item) {
      if (item.texte_id) return this.$router.push({name: 'TexteVue', params: {id: item.texte_id}})
      this.createTexte(item);
    },
    createTexte(item) {
      item.sending = true;
      const index = this.exercices.indexOf(item)
      Textes.Create({
        title: item.titre,
        texte_original: item.contenu,
        user_id: this.user.id,
        exercice: item.id,
        type: getTextType(item.type),
      })
          .then(({id}) => {
                const newItem = {
                  ...item,
                  texte_id: id,
                  fini: 0,
                  corrige: 0,
                  status: this.getStatusLabel({texte_id: id}),
                  key: this.getKey({texte_id: id})
                }
                this.exercices = [
                  ...this.exercices.slice(0, index),
                  newItem,
                  ...this.exercices.slice(index + 1),
                ]
              }
          )
    },
    getUserParams(user, options) {
      return options.reduce((p, {key}) => {
        p[key] = user?.[key];
        return p;
      }, {})
    },
    getOptions() {
      return [
        {key: "prenom", editable: {type: "input",}},
        {key: "pays", editable: {type: "input",}},
        {key: "mail"},
        {
          key: "acces_ecole",
          label: "Acces ecole",
          editable: {
            type: "checkbox",
            $input: this.giveAccess
          }
        },
        {
          key: "niveau_ecole",
          label: "Niveau",
          editable: {
            type: "radio",
            options: niveaux,
          }
        },
        {
          key: "role", label: "Role",
          editable: {
            type: "radio",
            options: DataFormat.Eleves.Roles.slice(1, 3).map(value => {
              return {value, text: DataFormat.Eleves.Labels.Roles[value]}
            }),
          },
          hide: !Auth.IsTeacher()
        },
        {key: "id", label: "Cle", hide: !Auth.IsTeacher()},
        {
          key: "eleves",
          editable: {
            type: 'select2',
            options: [],
          },
          hide: !Auth.IsAdmin(),
          if: () => this.userParams.role === 3,
        },
        {key: "notes", hide: true},
      ];
    },
    getEleves() {
      User.GetUsers().then(res => {
        this.options.find(op => op.key === 'eleves').editable.options = res.map(e => {
          return {
            value: e.id,
            label: e.prenom || e.mail
          }
        })
      })
    },
    getChanges() {
      const {user, userParams} = this;
      return Object.keys(userParams).reduce(
          (p, key) => {
            if (user[key] !== userParams[key]) p[key] = userParams[key];
            return p;
          },
          {id: user.id}
      )
    },
    giveAccess($event) {
      const {user} = this;

      function dateAcces() {
        return user.acces_ecole ? user.acces_ecole : new Date().toISOString();
      }

      this.userParams.acces_ecole = $event ? dateAcces() : null;
    },
    compare() {
      const {user, userParams, options} = this;
      return options.every(({key}) => user[key] === userParams[key]);
    },
    save() {
      User.UpdateUser(this.getChanges()).then(() => {
        this.user = {...this.user, ...this.userParams}
      })
    },
    logAs() {
      Auth.LogAs(this.user.id).then(() => {
        this.$router.push({name: "Main"})
      })
    },
  },
  created() {
    const {id} = this.user;
    User.GetUser(id).then(res => {
      this.user = res;
      this.userParams = this.getUserParams(res, this.options);
      if (this.userParams.role === 3) this.getEleves();
    });
    Exercice.List({}, id).then(list => {
      this.exercices = list.map(el => {
        return {...el, status: this.getStatusLabel(el), key: this.getKey(el)}
      });
    });
  }
}
</script>

<style scoped>
.form-control:disabled, .form-control[readonly] {
  background-color: #f8f9fa;
}

.input-group > .input-group-prepend > .input-group-text {
  width: 108px;
}

.card {
  margin: 0 1rem 0.5rem 1rem !important;
  max-width: calc(50% - 2rem);
}

.toggle.collapsed::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.toggle.not-collapsed::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
</style>